module.exports = __webpack_public_path__ + "static/img/item-2-1.387a2da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-2-1.png
// module id = Dysr
// module chunks = 2